<app-kazaplan-360-viewer [imageUrl]="imageUrl"></app-kazaplan-360-viewer>
<!--<app-footer></app-footer>-->

<!--'https://kazaplan360.appspot.com/assets/modules/marzipano/images/panorama.jpg'-->
